import '../../../assets/markdown.css'

import startsWith from 'lodash/startsWith'
import React from 'react'

import { DescriptionQuestionRender } from './DescriptionQuestionRender'
import MarkdownQuestionRenderer from './MarkdownQuestionRenderer'

function MarkdownQuestion({ question }) {
  return startsWith(question.text, '<') ? (
    <DescriptionQuestionRender value={question.text} />
  ) : (
    <MarkdownQuestionRenderer value={question.text} />
  )
}

export default MarkdownQuestion
